import { Injectable } from '@angular/core';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { UiHelperService } from '../../utils/services/ui-helper.service';
import { FormSectionTypeEnum, FormStepsService } from '../form-steps/form-steps.service';

declare let grecaptcha: any;

@Injectable()
export default class RecaptchaService {

  public recaptchaResponse: string;
  public mockRecaptcha: boolean = window['MOCK_RECAPTCHA'];
  public recaptchaSiteKey: string = window['SITE_KEY'];

  constructor(
    private commonInfo: CommonInfoService,
    private uiService: UiHelperService,
    private formStepsService: FormStepsService
  ) {
  }

  public resolved(captchaResponse: string) {
    this.recaptchaResponse = captchaResponse;
    this.formStepsService.openNextSection(FormSectionTypeEnum.RECAPTCHA);
  }

  public validateRecaptcha(): boolean {
    if (this.commonInfo.isOtherSalesOffer) {
      if (!this.recaptchaResponse && !this.mockRecaptcha) {
        this.uiService.scrollToElement('g-recaptcha');

        return false;
      }

      return true;
    }

    return true;
  }

  public reset() {
    if (this.commonInfo.isOtherSalesOffer && !this.mockRecaptcha) {
      grecaptcha?.reset();
    }
  }
}



